/* eslint no-use-before-define: ["error", { "functions": false }] */

import {ICON_NAMES, ICON_URLS, TRAVEL_MODES, VEHICLE_TYPES} from './constants'

function stepIconUrl(step) {
  const iconName = stepIconName(step)
  return ICON_URLS[iconName]
}

function stepIconName(step) {
  switch (step.travel_mode) {
    case TRAVEL_MODES.WALKING:
      return ICON_NAMES.WALKING;
    case TRAVEL_MODES.TRANSIT:
      return transitStepIconName(step);
    default:
      switch (step.mode) {
        case 'CAR':
          return ICON_NAMES.CAR;
        case 'MOTORCYCLE':
          return ICON_NAMES.MOTORCYCLE;
        case 'TAXI':
          return ICON_NAMES.TAXI;
        default:
          return ICON_NAMES.GENERIC;
      }
  }
}

function transitStepIconName(step) {
  const vehicleType = _.get(step, 'transit.line.vehicle.type')

  if (VEHICLE_TYPES.BUSES.includes(vehicleType)) {
    return ICON_NAMES.BUS
  } else if (VEHICLE_TYPES.RAILS.includes(vehicleType)) {
    return ICON_NAMES.TRAIN
  } else if (VEHICLE_TYPES.MARITIME.includes(vehicleType)) {
    return ICON_NAMES.SHIP
  } else if (VEHICLE_TYPES.CAR.includes(vehicleType)) {
    return ICON_NAMES.CAR
  } else if (VEHICLE_TYPES.MOTORCYCLE.includes(vehicleType)) {
    return ICON_NAMES.MOTORCYCLE
  } else if (VEHICLE_TYPES.TAXI.includes(vehicleType)) {
    return ICON_NAMES.TAXI
  }

  return ICON_NAMES.GENERIC
}

export {
  stepIconName,
  stepIconUrl
}
